import type { MaybeRefOrGetter } from 'vue';
import { computed, toValue } from 'vue';
import type { TrainingCourseDetail } from '~/types/academy/baseTraining';
import { ACADEMY_TRAININGS_SINGLE_KEY_PREFIX } from '~/utils/academy/constants';

function academyTrainingRequestUrl(identifier: string): string {
    return `/api/academy/docebo/${encodeURIComponent(identifier)}`;
}

export function useAcademyTraining(identifier: MaybeRefOrGetter<string>) {
    const requestUrl = computed(() => academyTrainingRequestUrl(toValue(identifier)));

    return useFetch<TrainingCourseDetail>(requestUrl, {
        key: () => `${ACADEMY_TRAININGS_SINGLE_KEY_PREFIX}:${toValue(identifier)}`,
        credentials: 'include',
        server: false
    });
}
